import React from "react";
import { Pencil } from "lucide-react";

interface EditButtonProps {
  /** Callback function when the button is clicked */
  onClick: () => void;
  /** Title/tooltip text for the button */
  title: string;
  /** Optional additional CSS classes */
  className?: string;
  /** Icon size in pixels */
  iconSize?: number;
}

/**
 * EditButton
 * Reusable button component for edit actions in tables.
 * Displays a pencil icon with consistent styling and hover effects.
 */
export const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  title,
  className = "",
  iconSize = 18,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-gray-500 hover:text-blue-600 transition-colors cursor-pointer ${className}`}
      title={title}
    >
      <Pencil size={iconSize} />
    </button>
  );
};

